import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-activate-deactivate-confirmation-add',
  templateUrl: './activate-deactivate-confirmation-add.component.html',
  standalone: false
})
export class ActivateDeactivateConfirmationAddComponent {

  constructor(
    public dialogRef: MatDialogRef<ActivateDeactivateConfirmationAddComponent>
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }
}
